import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  root: {
    flexGrow: 1,
  },
  typography: {
    button: {
      textTransform: "none",
      fontSize: "16px",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.color === "primary" && {
            backgroundColor: "#624892",
            ":hover": {
              backgroundColor: "#DB2BBB29",
              color: "#403e3b",
            },
          }),
          ...(ownerState.color === "secondary" && {
            backgroundColor: "#bd0095",
            color: "#ffff",
            ":hover": {
              backgroundColor: "#DB2BBB29",
              color: "#403e3b",
            },
          }),
        }),
        text: {
          fontFamily: ["Outfit", "sans-serif"].join(","),
        },
      },
    },

    MuiListItem: {
      styleOverrides: {
        root: {
          backgroundColor: "#624892",
          color: "white",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            // Controls checked color for the thumb
            color: "#624892",
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {},
        rounded: {},
      },
    },
    // MuiCheckbox:{
    //   styleOverrides:{
    //     root:{

    //     }
    //   }
    // }
  },

  palette: {
    primary: {
      main: "#f5f5fc",
      contrastText: "white",
    },
    secondary: {
      main: "#e6cae0",
      contrastText: "#f5f5fc",
    },
  },
});
